import { Box, Dialog, DialogContent, Typography, useTheme } from "@mui/material"
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded"
import { Image } from "components/Image"
import { useTranslation } from "providers/i18n"
import { Trans } from "react-i18next"
import { useMemo } from "react"
import { getIcon } from "utils/icon"

export const VerticalDirectionImageDialog = ({
  imageSrc,
  description,
  originLevelName,
  destinationLevelName,
  open,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const {
    root,
    container,
    highlightedText,
    image,
    descriptionContainer,
    headerContainer,
    primaryText,
    secondaryText,
    arrowIcon,
  } = theme.components[`VerticalDirectionImageDialog`]?.styleOverrides || {}

  const connectorIcon = useMemo(
    () =>
      getIcon(theme?.assets?.verticalStep?.connector, arrowIcon) || (
        <KeyboardArrowRightRoundedIcon sx={arrowIcon} fontSize="large" />
      ),
    [theme, arrowIcon]
  )

  const highlightedStepText = (
    <Typography variant="subTitle" component="span" sx={highlightedText} />
  )

  const isRtl = theme.isRtl

  return (
    <Dialog className="VerticalDirectionImageDialog-root" sx={root} open={open}>
      {open && (
        <DialogContent sx={container}>
          <Image src={imageSrc} sx={image} />
          <Box sx={descriptionContainer}>
            <Box sx={headerContainer}>
              <Typography sx={primaryText} component="span">
                {t("Step Floor", { value: originLevelName })}
              </Typography>
              <Box className={isRtl ? "is-rtl" : ""}>{connectorIcon}</Box>
              <Typography sx={primaryText} component="span">
                {t("Step Floor", { value: destinationLevelName })}
              </Typography>
            </Box>
            <Typography variant="caption" sx={secondaryText}>
              <Trans
                components={{
                  category: highlightedStepText,
                  destination: highlightedStepText,
                  intermediary: highlightedStepText,
                  toward: highlightedStepText,
                  turn: highlightedStepText,
                }}
              >
                {t(description?.text, {
                  category: t(description?.options?.category),
                  destination: t(description?.options?.destination),
                  intermediary: t(description.options?.intermediary),
                  toward: t(description.options?.toward),
                  turn: t(description.options?.turn),
                })}
              </Trans>
            </Typography>
          </Box>
        </DialogContent>
      )}
    </Dialog>
  )
}
